import http from './http';

// 会员卡名称
export const fetchCardDetail = () => {
  return http({
    url: '/member-card/query/card-sell-config',
  });
};

// 交班弹窗页--常规业务
const fetchHandoverBaseBusiness = () => {
  return http({
    url: '/shift/handover/pop-up/base-bus',
  });
};

// 交班弹窗页--会员卡相关
const fetchHandoverMemberCard = () => {
  return http({
    url: '/shift/handover/pop-up/member-card',
  });
};

// 获取交班信息
const fetchHandoverInfo = () => {
  return http({
    url: '/shift/handover/pop-up',
  });
};

// 获取当班人列表
const fetchDutyList = (data) => {
  return http({
    url: '/shift/handover/employees',
    method: 'POST',
    data,
  });
};

// 获取系统当前是否有当班人
const fetchOnDuty = () => {
  return http({
    url: '/shift/handover/check/present/duty',
  });
};

// 当班提交
const submitHandover = (data) => {
  return http({
    url: '/shift/handover/duty/submit',
    method: 'POST',
    data,
  });
};

// 获取交班报表
const fetchHandoverReports = (params) => {
  return http({
    url: `/shift/handover/${params.id}/report-form`,
  });
};

// // 交班报表页--常规业务
// const fetchHandoverReportsBaseBusiness = (params) => {
//   return http({
//     url: `/shift/handover/${params.id}/report-form/base-bus`,
//   });
// };

// // 交班报表页--会员卡相关
// const fetchHandoverReportsMemberCard = (params) => {
//   return http({
//     url: `/shift/handover/${params.id}/report-form/member-card`,
//   });
// };

// 交班抽屉-更新交班须知
const updateHandoverShiftText = (data) => {
  return http({
    method: 'POST',
    url: '/shift/handover/upd/ShiftText',
    data,
  });
};

// 交班抽屉-房间业务
const fetchHandoverRoomReport = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/pop-up/room',
    params,
  });
};

// 交班抽屉-前台业务
const fetchHandoverReceptionReport = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/pop-up/reception',
    params,
  });
};

// 交班抽屉-会员卡
const fetchHandoverMemberCardReport = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/pop-up/memberCard',
    params,
  });
};

// 交班抽屉-会员储值
const fetchHandoverMemberBalanceReport = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/pop-up/memberBalance',
    params,
  });
};

// 交班抽屉-获取任务状态
const fetchHandoverBillDetailStatus = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/billTaskByShiftId',
    params,
  });
};

// 交班抽屉-账务明细
const fetchHandoverBillDetailReport = (data) => {
  return http({
    method: 'POST',
    url: '/shift/handover/pop-up/bill-list',
    data,
  });
};

// 交班抽屉-刷新账务明细
const refreshHandoverBillDetailReport = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/pop-up/bill/refresh',
    params,
  });
};

// 交班抽屉-导出账务明细
const exportHandoverBillDetailReport = (params) => {
  return http({
    method: 'GET',
    url: '/shift/handover/data-output',
    responseType: 'blob',
    params,
  });
};

// 交班列表
const getHandoverReportList = (data) => {
  return http({
    method: 'POST',
    url: '/shift/handover/report-form/page',
    data,
  });
};

export {
  fetchHandoverBaseBusiness,
  fetchHandoverMemberCard,
  fetchHandoverInfo,
  fetchDutyList,
  fetchOnDuty,
  submitHandover,
  fetchHandoverReports,
  // fetchHandoverReportsBaseBusiness,
  // fetchHandoverReportsMemberCard,
  updateHandoverShiftText,
  fetchHandoverRoomReport,
  fetchHandoverReceptionReport,
  fetchHandoverMemberCardReport,
  fetchHandoverMemberBalanceReport,
  fetchHandoverBillDetailStatus,
  fetchHandoverBillDetailReport,
  refreshHandoverBillDetailReport,
  exportHandoverBillDetailReport,
  getHandoverReportList,
};
